export default __webpack_public_path__ + "static/iliad-epic-grow-header-video-be18fbae1338a693ea29b136d82231c4.mp4";